import { render } from "./searchQuery.vue?vue&type=template&id=636e0962"
import script from "./searchQuery.vue?vue&type=script&lang=js"
export * from "./searchQuery.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__